import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface GenVideoCtaTextModel extends BaseModel {
  variables?: { [key: string]: string } | GenVideoCtaTextVariables;
}

export interface GenVideoCtaTextVariables {
  Text: string;
}

export class GenVideoCtaTextInitVariables implements GenVideoCtaTextVariables {
  Text = '';
}

export class GenVideoCtaTextInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new GenVideoCtaTextInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
